import { useEffect } from 'react';

export const handlePostMessage = (data: any) => {
  window.parent.postMessage(data, '*');
};

const usePostMessage = (data: any) => {
  useEffect(() => {
    window.parent.postMessage(data, '*');
  }, [data]);
};

export default usePostMessage;
